import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';
import Dropdown from '../Dropdown';
import Link from '../../../components/core/Link';
import customComponents from './customComponents';
import SelectionList from './SelectionList';

const MAX_MENU_HEIGHT = 220;
const REMOVE_ALL_SELECTION_THRESHOLD = 1;

const customStyles = {
  control: (providedStyling) => ({
    ...providedStyling,
    height: 35,
    border: `1px solid ${theme.colors.gray.neutral}`,

    '& i': {
      marginBottom: 0,
    },
  }),
  placeholder: (providedStyling) => ({
    ...providedStyling,
    paddingLeft: 30,
  }),
  input: () => ({
    marginBottom: 8,
    marginLeft: 4,
  }),
};

const searchAndSelectStyles = {
  removeAllContainer: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 5,
  }),
  removeAll: css({
    fontWeight: 400,
  }),
};

class SearchAndSelect extends PureComponent {
  render() {
    const {
      testid,
      onChange,
      i13nLabel,
      options,
      value,
      onInputChange,
      inputValue,
      onRemoveSelection,
      onRemoveAllSelections,
      secondaryLabelKey,
      statusLabelType,
      styles,
      placeholder,
      isLoading,
      components,
    } = this.props;
    const { removeAllContainer, removeAll } = searchAndSelectStyles;

    return (
      <div>
        <Dropdown
          // CONFIGURABLE PROPS //
          testid={testid ? `${testid}-search-and-select` : 'search-and-select'}
          onChange={onChange}
          i13nLabel={i13nLabel}
          value={value}
          options={options}
          styles={Object.assign({}, customStyles, styles || {})}
          onInputChange={onInputChange}
          inputValue={inputValue}
          placeholder={placeholder}
          secondaryLabelKey={secondaryLabelKey}
          components={Object.assign({}, customComponents, components || {})}
          isLoading={isLoading}
          // STATIC PROPS //
          multi
          hideSelectedOptions
          maxMenuHeight={MAX_MENU_HEIGHT}
          controlShouldRenderValue={false}
          clearable={false}
          backspaceRemoves={false}
          tabSelectsValue={false}
        />
        <SelectionList
          selections={value}
          onRemoveSelection={onRemoveSelection}
          secondaryLabelKey={secondaryLabelKey}
          statusLabelType={statusLabelType}
        />
        {value?.length > REMOVE_ALL_SELECTION_THRESHOLD && (
          <div className={removeAllContainer}>
            <Link onClick={onRemoveAllSelections} testid="search-and-select__remove-all" className={removeAll}>
              Remove all
            </Link>
          </div>
        )}
      </div>
    );
  }
}

export default SearchAndSelect;
